export default {
   methods: {
      /**
       * Initialise a moment instance
       *
       * @return {Object}
       */
      allows: function (permission) {
         return this.permission(permission) === 1 || this.permission('super') === 1
      },
      permission: function (name) {
         let namespace = window.Laravel.settings.permissions.namespace
         let permission = (namespace ? namespace + ":" + name : name)

         return window.Laravel.auth.user.permissions[permission]
      }
   }
};
